import segmentProps from '../lib/segmentProps';

export default {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_protect_action_opened',
            props: {
                ...segmentProps,
                protect_user_type: '#context.protectUserType',
                user_file_type: '#context.userFileType',
                breach_type: '#context.breachType',
                action_type: '#context.actionType',
                number_of_sites: '#context.numberOfSites',
            },
        },
    },
};
